import { AutogenLayoutDemoDateTimeDialog } from "./autogen/AutogenLayoutDemoDateTimeDialog";

export class DemoDateTimeDialog extends AutogenLayoutDemoDateTimeDialog {
    getDemoPath() {
        return ["Dialogs", "Date/Time Pickers"];
    }
}
